/**
 * MainCard component for primary content sections, with padding and optional title.
 * @param {object} props - The props for MainCard.
 * @param {React.ReactNode} [props.title] - Optional title to display.
 * @param {object} [props.style] - Optional style overrides.
 * @param {React.ReactNode} [props.children] - Card content.
 */
import React, { Component } from "react";
import { Card } from '@mui/material'
import { any } from "prop-types";
import { useTheme } from "@mui/material/styles";

const MainCard = ({ children, sx, style }) => {
    const theme = useTheme();
    const isDark = theme.palette.mode === "dark";

    return (
        <Card
            style={style}
            sx={{
                boxShadow: 'none',
                borderRadius: '16px',
                border: `1px solid ${isDark ? "rgba(255, 255, 255, 0.1)" : "rgba(0, 0, 0, 0.08)"
                    }`,
                background: isDark
                    ? "rgba(255, 255, 255, 0.02)"
                    : "rgba(255, 255, 255, 0.8)",
                backdropFilter: "blur(10px)",
                padding: '24px',
                ...sx,
            }}
        >
            {children}
        </Card>
    );
};

MainCard.propTypes = {
    title: any,
    style: any,
    children: any,
};

MainCard.defaultProps = {
    title: null,
};

export default MainCard;